import * as React from "react"

const SocialIcon = ({ url, children }) => {
  return (
    <a
      href={url}
      target={"_blank"}
      rel={"noreferrer"}
      className={
        "group h-8 w-8 bg-blue-600 hover:bg-navy transition duration-500 ease-in-out rounded-full flex items-center justify-center"
      }
    >
      {children}
    </a>
  )
}

export default SocialIcon
